export default "__VITE_PUBLIC_ASSET__fb8df44f__"